import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {BehaviorSubject, of} from 'rxjs';

export interface UserSearch {
  id: number;
  name: string;
  open_task_count?: number;
  is_admin: number;
  is_super_admin: boolean;
  token?: string;
  in_review_task_count?: number;
  is_account_manager?: boolean;
  near_deadline_task_count?: number;
  pending_change_requests_count?: number;
  roles?: string[];
}

@Injectable()
export class UserSearchService {
  private userSubject = new BehaviorSubject<UserSearch | null>(null);
  user$ = this.userSubject.asObservable();

  constructor(private http: HttpClient) {}

  data = null;

  getAdmins = (filter: string = null, role: string = '', disableCache = true) => {
    let url = `rest-api/v1/admin/task-management/admins`;
    if (role) {
      url += `?role=${role}`;
    }
    if (!disableCache && Array.isArray(this.data) && this.data.length > 0) {
      return of(this.data);
    } else {
      return this.http.get<any>(url).pipe(
        map(response => {
          this.data = response.results;
          return this.data;
        }),
      );
    }
  };

  getByRole = (filter: string = null, role: string = '', disableCache = true) => {
    let url = `rest-api/v1/admin/task-management/current_and_former_admins/search`;
    if (role) {
      url += `?role=${role}`;
    }
    if (!disableCache && Array.isArray(this.data) && this.data.length > 0) {
      return of(this.data);
    } else {
      return this.http.get<any>(url).pipe(
        map(response => {
          this.data = response.results;
          return this.data;
        }),
      );
    }
  };

  getMe = () =>
    this.http.get<UserSearch>(`rest-api/v1/admin/task-management/admins/me`).pipe(
      catchError(err =>
        of({
          id: undefined,
          name: undefined,
          open_task_count: undefined,
          is_admin: 0,
        }),
      ),
    );
}
